<template>
  <BreadCrumb PageTitle="Notification" />
  <ViewNotification />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import ViewNotification from "../../components/Notification/ViewNotification.vue";

export default defineComponent({
  name: "ViewNotificationPage",
  components: {
    BreadCrumb,
    ViewNotification,
  },
});
</script>